import { lazy } from "react";

export const RehabilitatorDetailsAsync = lazy(
  () => import("./RehabilitatorDetails")
);
